import React, {ReactElement} from 'react';
import ModalConfirm from "./confirm/modal-confirm";


export default class ConfirmModalsManager {

    constructor() {}

    generic(title:string, message:any, onYesCallback:callback, params:any={}, toggleCallback?:callback) {

        // params: {}
        // comment, onNoCallback, yesBtnLabel, noBtnLabel

        gd.modal.showConfirm({
            header: {
                // type: 'white',
                title: title
            },
            component: ModalConfirm,

            params: {
                message         : message,
                onYesCallback   : onYesCallback,

                comment         : params.comment,
                onNoCallback    : params.onNoCallback,

                yesBtnLabel     : params.yesBtnLabel,
                noBtnLabel      : params.noBtnLabel
            },

            toggleCallback: toggleCallback
        });
    }

    genericText(title:string, message:string|ReactElement, onYesCallback:callback, params:any={}, toggleCallback?:callback) {

        // params: {}
        // comment, onNoCallback, yesBtnLabel, noBtnLabel

        const messageComponent = (
            <div className="message ui5-txt-less-important">{message}</div>
        )

        return gd.modals.confirm.generic(title, messageComponent, onYesCallback, params, toggleCallback)
    }

    deleteByName(itemTypeName:string, itemName:string, onYesCallback:callback) {

        gd.modal.showConfirm({
            header: {
                // type: 'white',
                title: 'Delete '+itemTypeName
            },
            component: require('./confirm/modal-confirm-delete.jsx'),

            params: {
                onYesCallback: onYesCallback,
                name: itemName
            }

        });
    }

    deleteByNameWithComment(itemTypeName:string, itemName:string, comment:string, onYesCallback:callback) {

        gd.modal.showConfirm({
            header: {
                // type: 'white',
                title: 'Delete '+itemTypeName
            },
            component: require('./confirm/modal-confirm-delete.jsx'),

            params: {
                onYesCallback: onYesCallback,
                name: itemName,
                comment: comment
            }

        });
    }

    deleteTextMessage(itemTypeName:string, text:string, onYesCallback:callback) {
        const message = (
            <div className="message">
                <div className="txt">{text}</div>
            </div>
        )

        gd.modals.confirm.deleteMessage(itemTypeName,message,onYesCallback);
    }

    deleteMessage(itemTypeName:string, message:any, onYesCallback:callback) {

        gd.modal.showConfirm({
            header: {
                // type: 'white',
                title: 'Delete '+itemTypeName
            },
            component: require('./confirm/modal-confirm-delete.jsx'),

            params: {
                onYesCallback: onYesCallback,
                message: message
            }

        });
    }

    saveChanges(onYesCallback:callback, onNoCallback:callback) {
        gd.modals.confirm.genericText('Save changes','The record has been updated, do you want to save changes?', () => {
            gd.modal.hide();
            if(onYesCallback) onYesCallback();
        }, {
            yesBtnLabel: 'Yes - Save changes',
            noBtnLabel: 'No - Discard changes',
            onNoCallback: onNoCallback
        });
    }


}
